<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="title-section form-section mb-0">
          <h1 class="page-title text-center">APPLICATION</h1>
          <h2 class="form-title text-center">Insurance Agent E&O Application</h2>
        </article>
        <article class="input-section form-section" >
          <div style="border: 2px solid black;" class="p-2">
            <p class="mt-1 mb-1">
              <strong>NOTICE:</strong> BY COMPLETING THIS APPLICATION YOU ARE APPLYING FOR INSURANCE BROKER/ AGENT ERRORS & OMISSIONS INSURANCE.
            </p>
            <p class="mt-1 mb-1">
              THIS APPLICATION IS FOR CLAIMS MADE AND REPORTED COVERAGE, WHICH APPLIES ONLY TO "CLAIMS" FIRST MADE AND REPORTED IN WRITING DURING THE "POLICY PERIOD," OR ANY EXTENDED REPORTED PERIOD. THE LIMIT OF LIABILITY TO PAY DAMAGES OR SETTLEMENTS WILL BE REDUCED AND MAY BE EXHAUSTED BY "DEFENSE COSTS," AND "DEFENSE COSTS" WILL BE APPLIED AGAINST YOUR DEDUCTIBLE. THE COVERAGE APPLIED FOR WITH THIS APPLICATION DIFFERS IN SOME RESPECTS FROM THAT AFFORDED UNDER OTHER POLICIES. READ THE ENTIRE APPLICATION CAREFULLY BEFORE SIGNING.             </p>
          </div>
        </article>
        <article class="form-heading title-section form-section flex">
          <h1 class="form-title">PART 1: APPLICANT INFORMATION</h1>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">1.</span>Name of Applicant:
          </label>
          <input
            type="text"
            name="nameOfApplicant"
            v-model="insuranceAgentApplication.nameOfApplicant"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('nameOfApplicant')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('nameOfApplicant') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">2.</span>
            Business Name (DBA):
          </label>
          <input
            type="text"
            name="businessName"
            v-model="insuranceAgentApplication.businessName"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('businessName')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('businessName') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section" >
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  <span class="mr-1">3.</span>
                  Physical Address
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="insuranceAgentApplication.customer.address"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('address')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="insuranceAgentApplication.customer.city"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('city')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="state"
                  v-model="insuranceAgentApplication.customer.state"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('state')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="zipCode"
                    v-model="insuranceAgentApplication.customer.zipCode"
                    class="orep-text-input w-100"
                    v-validate="'required|numeric|length:5'"
                    maxlength="5"
                    inputmode="numeric"
                    @keypress="!/^\d$/.test($event.key) ? ($event.preventDefault(), zipCodeError = 'Please enter numeric values only') : (zipCodeError = '')"
                    @input="validateBeforeSubmit()"
                >
                <span v-if="zipCodeError" class="text-danger small">{{ zipCodeError }}</span>
                <span
                  v-show="errors.has('zipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  Website
                </label>
                <input
                  type="text"
                  name="website"
                  v-model="insuranceAgentApplication.website"
                  class="orep-text-input w-100"

                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('website')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('website') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <div class="radio orep-radio-wrapper solo-checkbox" style="padding-top: 20px">
                  <label class="orep-label ml-1">
                    <input
                        type="checkbox"
                        name="checkIfMailAddressSame"
                        class="orep-radio w-40"
                        v-model="insuranceAgentApplication.checkIfMailAddressSame"
                    >
                    <span class="radio-span solo-checkbox-span" style="color: #046085">
                    Check this box if Mailing Address is the same
                  </span>
                  </label>
                </div>
              </div>
            </div>

            <div v-if="!insuranceAgentApplication.checkIfMailAddressSame" class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label mb-0 ml-1">
                  <span class="mr-1">4.</span>
                  Mailing Address:
                </label>
                <input
                  type="text"
                  name="mailingAddress"
                  v-model="insuranceAgentApplication.mailingAddress"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('mailingAddress')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingAddress') | filterText }}</span>
              </div>
            </div>
            <div v-if="!insuranceAgentApplication.checkIfMailAddressSame" class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                    type="text"
                    name="mailingCity"
                    v-model="insuranceAgentApplication.mailingCity"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('mailingCity')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingCity') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                    class="orep-select w-100"
                    style="height: 40px; width: 383px;"
                    name="mailingState"
                    v-model="insuranceAgentApplication.mailingState"
                    v-validate="'required'"
                    @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                    v-show="errors.has('mailingState')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingState') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="mailingZipCode"
                    v-model="insuranceAgentApplication.mailingZipCode"
                    class="orep-text-input w-100"
                    v-validate="'required|numeric|length:5'"
                    maxlength="5"
                    inputmode="numeric"
                    @keypress="!/^\d$/.test($event.key) ? ($event.preventDefault(), mailingZipCodeError = 'Please enter numeric values only') : (mailingZipCodeError = '')"
                    @input="validateBeforeSubmit()"
                >
                <span v-if="mailingZipCodeError" class="text-danger small">{{ mailingZipCodeError }}</span>
                <span
                    v-show="errors.has('mailingZipCode')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingZipCode') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1">5.</span><span class="qtn mrpx-5"></span>Phone:
                </label>
                <input
                  type="text"
                  name="phone"
                  v-model="insuranceAgentApplication.customer.phone"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('phone')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('phone') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Fax:
                </label>
                <input
                  type="text"
                  name="fax"
                  v-model="insuranceAgentApplication.customer.fax"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>Email:
                </label>
                <input
                  type="email"
                  name="email"
                  autocomplete="email"
                  v-model="insuranceAgentApplication.customer.email"
                  class="orep-text-input w-100"
                  v-validate="'required|email'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('email')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('email') | filterText }}</span>
              </div>

            </div>
          </div>

        </article>

        <article class="input-section form-section">
          <div class="row align-items-center mx-1 pb-0 pt-3">
            <label for class="orep-label">
              <span class="mr-1">6.</span>Applicant is: </label>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="individual"
                  value="individual"
                  class="orep-radio"
                  v-validate="'required|included:individual,partnership,corporation,llc'"
                  @change="validateBeforeSubmit()"
                  v-model="insuranceAgentApplication.applicantOwnership"
                >
                <span class="radio-span">Individual</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="partnership"
                  value="partnership"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="insuranceAgentApplication.applicantOwnership"
                >
                <span class="radio-span">Partnership</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="corporation"
                  value="corporation"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="insuranceAgentApplication.applicantOwnership"
                >
                <span class="radio-span">Corporation</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="llc"
                  value="llc"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="insuranceAgentApplication.applicantOwnership"
                >
                <span class="radio-span">LLC</span>
              </label>
            </div>
            <span
              v-show="errors.has('individual')"
              class="help is-danger form-errors text-danger mt-0 mb-2"
            >{{ errors.first('individual') | filterText }}</span>
          </div>
        </article>

        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">7.</span>Year Agency Established:
          </label>
          <input
              type="text"
              name="dateAgencyEstablished"
              v-model="insuranceAgentApplication.dateAgencyEstablished"
              class="orep-text-input"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
          >
          <span
              v-show="errors.has('dateAgencyEstablished')"
              class="help is-danger form-errors text-danger"
          >{{ errors.first('dateAgencyEstablished') | filterText }}</span>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">8.</span>
                Do you write insurance business outside of your home state?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessOutsideHome"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessOutsideHome"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessOutsideHome"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessOutsideHome"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('businessOutsideHome')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('businessOutsideHome') | filterText }}</span>
            </div>
          </div>
          <div class="row" v-if="insuranceAgentApplication.businessOutsideHome == true || insuranceAgentApplication.businessOutsideHome === 'true'">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                If Yes: A. Are you Licensed in every State you write business in?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="haveYouLicensedEveryState"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.haveYouLicensedEveryState"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="haveYouLicensedEveryState"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.haveYouLicensedEveryState"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('haveYouLicensedEveryState')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('haveYouLicensedEveryState') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.haveYouLicensedEveryState == true || insuranceAgentApplication.haveYouLicensedEveryState === 'true'">
            <label class="orep-label">B. Please list states you write business:
            </label>

            <input
                type="text"
                placeholder="Please explain:"
                class="orep-text-input js-orep-input"
                v-if="insuranceAgentApplication.haveYouLicensedEveryState == true || insuranceAgentApplication.haveYouLicensedEveryState === 'true'"
                name="statesWriteBusiness"
                v-model="insuranceAgentApplication.statesWriteBusiness"
                @input="validateBeforeSubmit()"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">9.</span>
                Do you have more than one office location?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="haveMoreThanOneOffice"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.haveMoreThanOneOffice"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="haveMoreThanOneOffice"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.haveMoreThanOneOffice"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('haveMoreThanOneOffice')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('haveMoreThanOneOffice') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.haveMoreThanOneOffice == true || insuranceAgentApplication.haveMoreThanOneOffice === 'true'">
            <label class="orep-label text-danger">If Yes: If you are new to IBDPro, please send a list of locations to <a href="mailto:service@ibdpro.com">service@ibdpro.com</a>
            </label>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row pb-3">
            <div class="col-md-auto">
              <label for class="orep-label">
                <span class="mr-1">10.</span>Ownership Name
              </label>
              <input
                  type="text"
                  id="ownershipNameOne"
                  name="ownershipNameOne"
                  v-model="insuranceAgentApplication.ownershipNameOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('ownershipNameOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipNameOne') | filterText }}</span>
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <label for class="orep-label">
                Ownership %
              </label>
              <input
                  type="text"
                  id="ownershipOne"
                  name="ownershipOne"
                  v-model="insuranceAgentApplication.ownershipOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('ownershipOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipOne') | filterText }}</span>
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <label for class="orep-label">
                Active
              </label>
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveOne"
                        id="ownershipActiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveOne"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveOne"
                        id="ownershipActiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-validate="'required'"
                        v-model="insuranceAgentApplication.ownershipActiveOne"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('ownershipActiveOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipActiveOne') | filterText }}</span>
            </div>
            <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <label for class="orep-label">
                Title
              </label>
              <input
                  type="text"
                  id="ownershipTitleOne"
                  name="ownershipTitleOne"
                  v-model="insuranceAgentApplication.ownershipTitleOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('ownershipTitleOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipTitleOne') | filterText }}</span>
            </div>
            <div class="col-md-2">
              <label for class="orep-label">
                Yrs of Experience
              </label>
              <input
                  type="text"
                  id="ownershipExperienceOne"
                  name="ownershipExperienceOne"
                  v-model="insuranceAgentApplication.ownershipExperienceOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('ownershipExperienceOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipExperienceOne') | filterText }}</span>
            </div>
          </div>
          <!-- Section 2 -->
          <div class="row pb-3">
            <div class="col-md-auto">
              <input
                  type="text"
                  id="ownershipNameTwo"
                  name="ownershipNameTwo"
                  v-model="insuranceAgentApplication.ownershipNameTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2">
              <input
                  type="text"
                  id="ownershipTwo"
                  name="ownershipTwo"
                  v-model="insuranceAgentApplication.ownershipTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveTwo"
                        id="ownershipActiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveTwo"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveTwo"
                        id="ownershipActiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveTwo"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipTitleTwo"
                  name="ownershipTitleTwo"
                  v-model="insuranceAgentApplication.ownershipTitleTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipExperienceTwo"
                  name="ownershipExperienceTwo"
                  v-model="insuranceAgentApplication.ownershipExperienceTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>

          <!-- Section 3 -->
          <div class="row pb-3">
            <div class="col-md-auto">
              <input
                  type="text"
                  id="ownershipNameThree"
                  name="ownershipNameThree"
                  v-model="insuranceAgentApplication.ownershipNameThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipThree"
                  name="ownershipThree"
                  v-model="insuranceAgentApplication.ownershipThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveThree"
                        id="ownershipActiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveThree"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveThree"
                        id="ownershipActiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveThree"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipTitleThree"
                  name="ownershipTitleThree"
                  v-model="insuranceAgentApplication.ownershipTitleThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipExperienceThree"
                  name="ownershipExperienceThree"
                  v-model="insuranceAgentApplication.ownershipExperienceThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>
          <!-- Section 4 -->
          <div class="row pb-3">
            <div class="col-md-auto">
              <input
                  type="text"
                  id="ownershipNameFour"
                  name="ownershipNameFour"
                  v-model="insuranceAgentApplication.ownershipNameFour"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipFour"
                  name="ownershipFour"
                  v-model="insuranceAgentApplication.ownershipFour"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveFour"
                        id="ownershipActiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveFour"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveFour"
                        id="ownershipActiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveFour"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipTitleFour"
                  name="ownershipTitleFour"
                  v-model="insuranceAgentApplication.ownershipTitleFour"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipExperienceFour"
                  name="ownershipExperienceFour"
                  v-model="insuranceAgentApplication.ownershipExperienceFour"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>
          <!-- Section 5 -->
          <div class="row pb-3">
            <div class="col-md-auto">
              <input
                  type="text"
                  id="ownershipNameFive"
                  name="ownershipNameFive"
                  v-model="insuranceAgentApplication.ownershipNameFive"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipFive"
                  name="ownershipFive"
                  v-model="insuranceAgentApplication.ownershipFive"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveFive"
                        id="ownershipActiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveFive"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveFive"
                        id="ownershipActiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownershipActiveFive"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipTitleFive"
                  name="ownershipTitleFive"
                  v-model="insuranceAgentApplication.ownershipTitleFive"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipExperienceFive"
                  name="ownershipExperienceFive"
                  v-model="insuranceAgentApplication.ownershipExperienceFive"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-insurance-agent-application-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-insurance-agent-application-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-insurance-agent-application-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-insurance-agent-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('ibdpro-insurance-agent-application-6')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid|| !state.pageFiveIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('ibdpro-insurance-agent-application-2')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {APP_STATUS, STATES} from "../../utils/constants";

export default {
  name: "ibdpro-insurance-agent-application-1",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    insuranceAgentApplication() {
      return this.$store.state.insuranceAgentApplication.insuranceAgentApplication;
    },
    state() {
      return this.$store.state.insuranceAgentApplication;
    },
    errorMsg() {
      return this.$store.state.insuranceAgentApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/ibdpro-insurance-agent-application-amba/' || this.insuranceAgentApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/ibdpro-insurance-agent-application-realshield/' || this.insuranceAgentApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.insuranceAgentApplication.customer.contactName = this.state.insuranceAgentApplication.nameOfPrimaryLicensed;
      this.insuranceAgentApplication.customer.companyName = this.state.insuranceAgentApplication.nameOfApplicant;
      this.insuranceAgentApplication.customer.isInsuranceAgentApplication = 'True';
      this.insuranceAgentApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.insuranceAgentApplication.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.insuranceAgentApplication.customer.partnerName = 'Realshield';
      }
      this.insuranceAgentApplication.customer.partnerName = 'IBD';
      this.$store.dispatch('insuranceAgentApplication/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    this.validateBeforeSubmit();
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.insuranceAgentApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
};
</script>

<style scoped>

</style>
